import utils from '@src/common/utils'
const tableOption = function (that) {
  return {
    page: false,
    selection: false,
    index: true,
    indexLabel: '序号',
    refreshBtn: false,
    columnBtn: false,
    stripe: true,
    addBtn: false,
    editBtn: false,
    delBtn: false,
    addFormSlot: true,
    viewFormSlot: true,
    align: 'left',
    size: 'small',
    maxHeight: '100%',
    labelWidth: '100px',
    menuAlign: 'center',
    searchMenuSpan: 6,
    searchBtn: false,
    dialogHeight: 400,
    dialogWidth: '700px',
    emptyText: '暂无数据',
    column: [
      {
        label: '摄像机名称',
        prop: 'deviceName',
        addDisplay: false,
        editDisplay: false,
        viewDisplay: false,
        span: 24,
        align: 'center'
      },
      // {
      //   label: '播放时间',
      //   prop: 'playTime',
      //   addDisplay: true,
      //   editDisplay: true,
      //   viewDisplay: true,
      //   overHidden: true
      // }
    ]
  }
}
export default tableOption